import styled from 'styled-components';
import getRatingsColor from '../../../../utils/getRatingsColor';

export const FiltersWrapperDiv = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    margin: 0 0 ${props.theme.spacing.base} 0;
    opacity: ${props.opacity};
    pointer-events: ${props.pointer}
`);

export const FlexColumnDiv = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  `
);

// export const StarRatingWrapperSpan = styled.span(
//   props => `
//   display: flex;
//   flex-wrap: wrap;
//   flex-direction: row;
//   align-items: center;
//   padding-bottom: ${props.theme.spacing.small.s5};
//   margin-right: ${props.theme.spacing.base};
// `,
// );

// export const AverageReviewWrapper = styled.div(
//   props => `
//     margin-right: ${props.theme.spacing.small.s5};
//     padding: ${props.theme.spacing.small.s2} ${props.theme.spacing.small.s5};
//     border-radius: ${props.theme.misc.borderRadius.small};
//     // background-color: ${getRatingsColor(props.ratingCount)};
//     width: ${props.theme.spacing.large.l40};
// `);

// export const AverageReviewText = styled.span(
//   props => `
//     font-size: ${props.theme.font.base};
//     font-weight: ${props.theme.font.fontWeight.bold};
//     color: ${props.theme.colors.black.base};
//     text-align: ${props.theme.font.textAlign.center};
//   `,
// );

export const FiltersInfoBlockWrapperDiv = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
`);

export const AppliedFilterWrapper = styled.div(
  props => `
    position: sticky;
    top: 16.1rem;
    background-color: ${props.theme.colors.white.bgWhite};
    z-index: ${props.theme.misc.zIndex.xxlarge};
  `
)

export const FiltersHeaderBlockDiv = styled.div(
  props => `
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l15} 0 ${props.theme.spacing.large.l15};
`);

export const FilterHeading = styled.h3(
  props => `
  display: inline-flex;
  font-weight: ${props.theme.font.fontWeight.bold};
  font-size: ${props.theme.font.large.font14};
`,
);

export const ClearTextSpan = styled.span(
  props => `
    cursor: pointer;
    margin-right: ${props.theme.spacing.small.s5};
    font-weight: ${props.theme.font.fontWeight.bold};
    color: ${props.isactive === 'true' ? props.theme.colors.goBrand.blue : props.theme.colors.grey.grey50};
`);

export const AppliedFiltersWrapperDiv = styled.div(
  props => `
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
`);

export const FilterCheckBoxListWrapper = styled.div(
  props => `
    width: 100%;
    padding: ${props.theme.spacing.small.s5} ${props.theme.spacing.small.s5} ${props.theme.spacing.large.l15}
      ${props.theme.spacing.small.s5};
`);

export const TextTruncatorSpan = styled.span(
  props => `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: ${props.theme.spacing.large.l15};
`);
